import React from 'react';
import { AdminButton } from './components';

interface AdminAccessMessageProps {
  actionLabel?: string;
  ariaLabel: string;
  message: string;
  onAction?: () => void;
  status?: boolean;
  title: string;
}

export const AdminAccessMessage: React.FC<AdminAccessMessageProps> = ({
  actionLabel,
  ariaLabel,
  message,
  onAction,
  status = false,
  title,
}) => (
  <div className="pipeex-admin admin-access">
    <main
      aria-label={ariaLabel}
      className="pipeex-admin admin-access__panel admin-access__panel--message"
    >
      <span className="admin-access__mark" aria-hidden="true" />
      <h1>{title}</h1>
      <p role={status ? 'status' : undefined}>{message}</p>
      {actionLabel && onAction && (
        <AdminButton className="admin-access__action" onClick={onAction} type="button">
          {actionLabel}
        </AdminButton>
      )}
    </main>
  </div>
);

interface AdminLoginSurfaceProps {
  error: string | null;
  loading: boolean;
  onPasswordChange: (value: string) => void;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  onUsernameChange: (value: string) => void;
  password: string;
  username: string;
}

export const AdminLoginSurface: React.FC<AdminLoginSurfaceProps> = ({
  error,
  loading,
  onPasswordChange,
  onSubmit,
  onUsernameChange,
  password,
  username,
}) => (
  <div className="pipeex-admin admin-access">
    <main aria-label="Super admin login" className="pipeex-admin admin-access__panel">
      <div className="admin-access__brand">PipeEX admin</div>
      <h1>Super admin login</h1>
      <p className="admin-access__intro">Sign in with a super administrator account.</p>
      <form className="admin-access__form" onSubmit={onSubmit}>
        {error && <div className="admin-access__alert" role="alert">{error}</div>}
        <label htmlFor="admin-username">Username</label>
        <input
          autoComplete="username"
          autoFocus
          id="admin-username"
          onChange={(event) => onUsernameChange(event.target.value)}
          required
          type="text"
          value={username}
        />
        <label htmlFor="admin-password">Password</label>
        <input
          autoComplete="current-password"
          id="admin-password"
          onChange={(event) => onPasswordChange(event.target.value)}
          required
          type="password"
          value={password}
        />
        <AdminButton
          className="admin-access__submit"
          disabled={loading}
          type="submit"
          variant="primary"
        >
          {loading ? 'Signing in…' : 'Sign in'}
        </AdminButton>
      </form>
    </main>
  </div>
);
